import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Servicios
import { getHistorialVentas, getDetalleVenta } from '../../../services/HistorialVentasService';
import { anularVentas } from '../../../services/VentasService';


// Estilos
import '../../static/Global.css';
import '../../static/Home.css';
import '../../static/Aside.css';
import '../../static/Flotante.css';
import '../../static/Movimiento.css';



function DashboardVentas() {
    // 1. Definición de Estados (Soluciona errores 'not defined')
    const [ventas, setVentas] = useState([]);
    const [detalles, setDetalles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ventaSeleccionada, setVentaSeleccionada] = useState(null);
    
    // Si usas modales en esta vista, definirlos aquí:
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({});

    const location = useLocation();

    // Función auxiliar para clases activas
    const isActive = (path) => location.pathname === path ? 'active' : '';

    // 2. Cargar cabeceras al montar el componente
    useEffect(() => {
        cargarVentas();
    }, []);

const cargarVentas = async () => {
    setLoading(true);
    const data = await getHistorialVentas(); // Usando el service
    setVentas(data);
    setLoading(false);
};

const verDetalle = async (venta) => {
    setVentaSeleccionada(venta);
    const data = await getDetalleVenta(venta.venta_id); // Usando el service
    setDetalles(data);
};

const handleAnular = async (e, id) => {
    e.stopPropagation(); // Evita que se abra el modal al hacer clic en el botón
    const confirmar = window.confirm(`¿Estás seguro de que deseas ANULAR la venta #${id}? El stock se restaurará automáticamente.`);
    
    if (confirmar) {
        try {
            await anularVentas(id); // Llamada a tu service
            alert("Venta anulada con éxito.");
            cargarVentas(); // Refresca la tabla
        } catch (error) {
            alert("Error al anular: " + error.message);
        }
    }
};

// Función para estilo dinámico del estado
const getEstadoStyle = (estado) => {
    if (estado === 'VENTA ANULADA') return { color: '#dc3545', fontWeight: 'bold' };
    return { color: '#28a745', fontWeight: 'bold' };
};

return (
    <section className="main__content">
        <div className="table-container">
            <div className="table-header" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>GESTIÓN DE VENTAS</h2>
                
                <Link to="/DashboardRegistrarVentas" className="btn-vender-sidebar">
                    <i className="fa-solid fa-cart-shopping"></i> Nueva Venta
                </Link>
            </div>

            <div className="table-responsive">
                <table className="novatech-table">
                    <thead>
                        <tr>
                            <th>ID Venta</th>
                            <th>Usuario</th>
                            <th>Fecha</th>
                            <th>Cliente</th>
                            <th>Estado</th>
                            <th>Total</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="6">Cargando ventas...</td></tr>
                        ) : (
                            ventas.map((v) => (
                                <tr key={v.venta_id} onClick={() => verDetalle(v)} style={{ cursor: 'pointer' }}>
                                    <td>#{v.venta_id}</td>
                                    <td>{v.usuario}</td>
                                    <td>{v.fecha}</td>
                                    <td>{v.cliente}</td>
                                    <td style={getEstadoStyle(v.estado)}>{v.estado}</td>
                                    <td>S/ {Number(v.total).toFixed(2)}</td>
                                    <td style={{ display: 'flex', gap: '10px' }}>
                                        <button className="btn-edit" title="Ver Detalle">
                                            <i className="fa fa-eye"></i>
                                        </button>
                                        
                                        {/* Solo mostramos el botón de anular si la venta está ACTIVA */}
                                        {v.estado !== 'ANULADA' && (
                                            <button 
                                                className="btn-delete" 
                                                onClick={(e) => handleAnular(e, v.venta_id)}
                                                title="Anular Venta"
                                                style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px' }}
                                            >
                                                <i className="fa-solid fa-ban"></i>
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>

        {/* ====== MODAL DE DETALLE ====== */}
        {ventaSeleccionada && (
            <div className="modal-overlay" onClick={() => setVentaSeleccionada(null)}>
                <div className="modal-content-custom animate__animated animate__fadeInDown" onClick={(e) => e.stopPropagation()}>
                    <button className="btn-close-modal" onClick={() => setVentaSeleccionada(null)}>X</button>
                    
                    <h3>DETALLE DE VENTA: #{ventaSeleccionada.venta_id}</h3>
                    <hr />
                    <div style={{ marginBottom: '15px' }}>
                        <p><strong>Vendedor:</strong> {ventaSeleccionada.usuario}</p>
                        <p><strong>Cliente:</strong> {ventaSeleccionada.cliente}</p>
                        <p><strong>Fecha:</strong> {ventaSeleccionada.fecha}</p>
                        <p><strong>Estado:</strong> <span style={getEstadoStyle(ventaSeleccionada.estado)}>{ventaSeleccionada.estado}</span></p>
                    </div>

                    <div className="table-responsive">
                        <table className="novatech-table">
                            <thead>
                                <tr>
                                    <th>Producto</th>
                                    <th>Cant.</th>
                                    <th>Precio</th>
                                    <th>Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                {detalles.map((d, index) => (
                                    <tr key={index}>
                                        <td>{d.nombre}</td>
                                        <td>{d.cantidad}</td>
                                        <td>S/ {Number(d.precio_venta).toFixed(2)}</td>
                                        <td>S/ {Number(d.subtotal).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ textAlign: 'right', marginTop: '20px' }}>
                        <h3 style={{ color: '#007bff' }}>Total: S/ {Number(ventaSeleccionada.total).toFixed(2)}</h3>
                    </div>
                </div>
            </div>
        )}
    </section>
);

}

export default DashboardVentas;